import { profileNavKey } from "./profile-nav-key";

export const tabList = [
    { value: profileNavKey.ADMIN, name: 'Admin' },
    { value: profileNavKey.SELF_REGISTRATION_DATA, name: 'Self-registered Data' },
    { value: profileNavKey.DONOR_DATA, name: 'Donor Data' },
    { value: profileNavKey.MEDICAL_DETAILS, name: 'Medical Details' },
    { value: profileNavKey.HLA_INFO, name: 'HLA Info' },
    { value: profileNavKey.RECORDS, name: 'Records' },
    { value: profileNavKey.CT_SCAN, name: 'CT Scan' },
    { value: profileNavKey.DECLINES, name: 'Declines' },
    { value: profileNavKey.ACCEPTS, name: 'Accepts' },
    { value: profileNavKey.ADP, name: 'ADP' }
];